import { render } from "./InfiniteLoading.vue?vue&type=template&id=35670efe&scoped=true&ts=true"
import script from "./InfiniteLoading.vue?vue&type=script&lang=ts"
export * from "./InfiniteLoading.vue?vue&type=script&lang=ts"

import "./InfiniteLoading.vue?vue&type=style&index=0&id=35670efe&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35670efe"]])

export default __exports__